<div *ngIf="!isLoading">
  <div class="btn-list">
    <div class="btn-icon" *ngIf="programa.permissions.edit">
      <a [routerLink]="editar()">
        <img src="assets/images/svgs/Editar.svg" alt="Editar" tooltip="Editar" placement="bottom">
      </a>
    </div>
    <button type="button" class="btn-back" (click)="voltar()">Voltar</button>
  </div>

  <div class="info-page">
    <h3>Programa</h3>
  </div>

  <div class="list-info">
    <h4>Programa:</h4>
    <p class="destaque">{{ programa?.title }}</p>
  </div>

  <div class="list-info">
    <h4>Descrição:</h4>
    <p>{{ programa?.description }}</p>
  </div>

  <div class="list-info">
    <h4>Órgão responsável:</h4>
    <p>{{ programa?.agency?.name }}</p>
  </div>

  <div class="list-info">
    <h4>Gerente:</h4>
    <p>{{ programa?.manager?.name }}</p>
  </div>

  <div class="list-info">
    <h4>Gerente Adjunto:</h4>
    <p>
      <span *ngFor="let item of programa?.manager_adjunct">{{item.name}}<br></span>
    </p>
  </div>

  <div class="list-info">
    <h4>Ativo:</h4>
    <p>{{ (programa?.actived) ? "SIM" : "NÃO" }}</p>
  </div>
</div>

<app-loading [loader]="isLoading"></app-loading>
